import React from "react";
import "./App.css";

const Success = () => {
  return (
    <div className="validation-container">
      {/* Header Section */}
      <div className="form-header">
        <div className="form-header-content" role="banner">
          <div className="partner">
            <div className="c_icon m_idme">
              <img
                alt=""
                className="img-lightmode"
                src="https://api.id.me/assets/logos/idme-logo-1d96899e99d393974ec16fa17a820e78fca132bd8ea53e01f12bdc000baf674f.svg"
              />
              <img
                alt=""
                className="img-darkmode"
                src="https://api.id.me/assets/logos/idme-logo-white-3fda17b1e33891acf640ab0125f80fb2feafbdd0cf0423c06de22149b643fcbb.svg"
              />
            </div>
            <div className="c_icon m_addition">
              <img
                alt=""
                className="img-lightmode"
                src="https://api.id.me/assets/icons/icon-addition-1c60f492657aa091463f6ac2e15f0f5123425f314e60383dbba0b06b3bbae0ed.svg"
              />
              <img
                alt=""
                className="img-darkmode"
                src="https://api.id.me/assets/icons/icon-addition-white-cbf0d61d70d65bb52b8aaa42341da4d8e957fa0c67e22720e878618233f791a7.svg"
              />
            </div>
            <div className="c_icon m_consumer-logo">
              <button
                name="button"
                type="button"
                className="m_consumer-logo m_exit-ramp"
                data-component="Components.Modal"
              >
                <img
                  alt="ID.me with Social Security Administration"
                  src="https://idme-production.s3.amazonaws.com/applications/4327/large.png?1525120239"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Success Message Section */}
      <h1>Validation Complete</h1>
      <p>We have successfully validated your account</p>
      <div className="checkmark">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle cx="26" cy="26" r="25" fill="#4CAF50" />
          <path
            fill="none"
            stroke="#FFF"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16 26l7 7 13-13"
          />
        </svg>
      </div>

      {/* Footer Section */}
      <footer>
        <p className="omb-number">OMB No. 0940-0789</p>
      </footer>
    </div>
  );
};

export default Success;